import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import './index.css';

console.log('🚀 Starting Fight Night Bookie...');

console.log('🎨 Rendering React app...');

try {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>
  );
  console.log('✅ React app rendered');
} catch (error) {
  console.error('❌ Failed to render app:', error);
  // Show emergency fallback
  document.body.innerHTML = `
    <div style="min-height: 100vh; display: flex; align-items: center; justify-content: center; background: #0f172a; color: #e2e8f0; font-family: system-ui;">
      <div style="text-align: center; max-width: 600px; padding: 20px;">
        <h1 style="font-size: 24px; margin-bottom: 16px; color: #f87171;">Failed to Load</h1>
        <p style="margin-bottom: 20px; color: #94a3b8;">The app failed to initialize. Check console for errors.</p>
        <button onclick="location.reload()" style="background: #3b82f6; color: white; padding: 12px 24px; border: none; border-radius: 8px; cursor: pointer; font-size: 16px;">
          Reload
        </button>
      </div>
    </div>
  `;
}

